<template>
<div>
  <span v-if="isText" :key="color" :style="{ color }" v-text="text" />
  <el-tag
    v-else
    :type="tagType"
    size="mini"
    v-text="text"
  />
</div>
</template>

<script>
export default {
  name: 'Status',
  props: ['data', 'row'],
  computed: {
    isTag() {
      return this.data && this.data.isTag;
    },
    isText() {
      let isText = this.data && this.data.isText;

      // 不是tag的情况，默认是text
      if (!this.isTag) {
        isText = true;
      }
      return isText;
    },
    text() {
      return typeof this.data === 'string' ? this.data : this.data.text;
    },
    color() {
      const data = typeof this.data === 'string' ? { text: this.data } : this.data;
      return data.color || '#67c23a';
    },
  },
};
</script>

<style>

</style>
